import {types} from 'mobx-state-tree';

const AlarmTypesModel = types.model('AlarmTypesModel', {
  key: types.string,
  name: types.string,
});

export default AlarmTypesModel;
